import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
} from 'recharts';
import { secondsToHours } from './chartUtils';
import type { BreakdownEmployee } from '~/common/api/zeiterfassungServerApi/ProjectRecordApi';
import useTranslate from '~/common/utils/translate';

interface Props {
  data: BreakdownEmployee[];
}

export const ProjectHoursByEmployeeChart: React.FC<Props> = ({ data }) => {
  const t = useTranslate();
  const chartData = data.map((e) => ({
    name: e.employee_name || `#${e.employee_id}`,
    hours: secondsToHours(e.total_duration_seconds),
  }));

  return (
    <Box bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="lg" p={3}>
      <Text fontSize="sm" fontWeight="600" mb={2}>
        {t('projectRecords.chart.projectHoursByEmployee')}
      </Text>
      <Box h="200px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} unit="h" />
            <Tooltip />
            <Bar dataKey="hours" fill="#3182ce" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};
